export const ChangePwdInitialValues = {
  currentpwd: "",
  newpwd: "",
  repeatpwd: "",
};
